import React from "react";
import TableRow from "../../../../../Components/Common/TableRow";
import TableData from "../../../../../Components/Common/TableData";
import { convertToLocalDateTime } from "../../../../../utils/convertToLocalDateTime";
import TableRowPerAction from "../../../../../Components/Common/TableRowPerAction";
import { useAlert } from "../../../../../Context/AlertContext";
import useToastError from "../../../../../hooks/useErrorToast";
import useSWRMutation from "swr/mutation";
import { liveClassSubsUrls } from "../../../../../Api/Auth/ApiUrls";
import { sendDeleteRequestAuth } from "../../../../../Api/swrConfig";
import { toast } from "react-toastify";
import { liveClassUrls } from "../../../../../Api/Auth/AppUrls";

const LiveClassesRow = ({ row, mutate, onEditClick }) => {
  const { showAlert, setIsLoading } = useAlert();
  const { showErrorToast } = useToastError();

  const { trigger: deleteTrigger } = useSWRMutation(
    liveClassSubsUrls.delete(row._id),
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );

  const handleDelete = () => {
    showAlert(
      `Are you sure you want to delete the live subscription "${row.title}"?`,
      async () => {
        setIsLoading(true);
        await deleteTrigger(row._id);
      }
    );
  };
  return (
    <>
      <TableRow key={row._id} link={`${liveClassUrls.liveClasses}/${row._id}`}>
        <TableData>{row.title}</TableData>
        <TableData>{row?.category?.title}</TableData>
        <TableData>
          {convertToLocalDateTime(row.startDate)?.split(",")?.[0]}
        </TableData>
        <TableData>
          {convertToLocalDateTime(row.endDate)?.split(",")?.[0]}
        </TableData>
        <TableData>{row.price}</TableData>
        <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>
        <TableRowPerAction
          onEdit={() => onEditClick(row)}
          onDelete={handleDelete}
        />
      </TableRow>
    </>
  );
};

export default LiveClassesRow;
